jQuery( document ).ready(function() {

    if ( document.querySelector('header')) {

        function dynamic_header(){
            window.onscroll = function(){position_header()}

            const header = document.querySelector(".header-fixed")
            const sticky = header.clientHeight;
        
            function position_header() {
                if (window.pageYOffset > sticky) {
                    header.classList.remove("hide")
                    header.classList.add("fixed")
                } else {
                    header.classList.remove("fixed")
                    header.classList.add("hide")
                }
            }
            position_header()
        }
        dynamic_header()

        const headerMenu = document.querySelector('.navbar-mobile')
        function menu(element){
            if(element.checked === true){
                headerMenu.classList.add('shown')
                Array.from(document.querySelectorAll(".navbar-toggle")).forEach(element => {
                    element.checked = true
                })
            } else {
                headerMenu.classList.remove('shown')
            }
            Array.from(document.querySelectorAll(".navbar-toggle")).forEach(element => {
                element.removeEventListener('click', ()=>{
                    menu(element)
                })
            })    
        }
        Array.from(document.querySelectorAll(".navbar-toggle")).forEach(element => {
            element.addEventListener('click', ()=>{
                menu(element)
            })
        })
        document.querySelector('.navbar-toggle-close').addEventListener('click', ()=> {
            Array.from(document.querySelectorAll(".navbar-toggle")).forEach(element => {
                element.checked = false
                headerMenu.classList.remove('shown')
            }) 
        })

        gsap.registerPlugin(ScrollTrigger, SplitText, ScrollToPlugin)
    }
})